// This component is used as a placeholder in a grid or in any case an empty element is needed

const EmptyElement = () => {
    return <div></div>;
};

export default EmptyElement;
